





















import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator';
import BButton from 'buefy/src/components/button/Button.vue';
import {Action, Getter, State} from 'vuex-class';
import BDropdown from 'buefy/src/components/dropdown/Dropdown.vue';
import BDropdownItem from 'buefy/src/components/dropdown/DropdownItem.vue';

import {LookupDistance, lookupIcon, LookupIcon} from '@/store/types';

/* tslint:disable:no-console */

const namespace = 'userState';
@Component({
    components: {
        BDropdown,
        BDropdownItem,
        BButton,

    },
})
export default class MAFDropdown extends Vue {
    @Prop() public readonly options!: LookupIcon[];
    @Prop() public readonly selected!: string | undefined;
    @Prop() public readonly prevSelectedOne!: string | undefined;
    @Prop() public readonly prevSelectedTwo!: string | undefined;
    @Prop() public readonly position: string | undefined;
    @Prop() public readonly title!: string;

    public columns: number;
    public columnOptions: LookupIcon[][];
    public definedColumns: any[] = [];
    // public isLoaded: Boolean = false;

    constructor() {
        super();
        this.columns = 0;
        this.columnOptions = [];

        // this.definedColumns = this.setUpColumns();
    }

    public close() {
        // @ts-ignore
        this.$refs.dropdown.toggle();
    }

    @Emit('emit-selected')
    public emitSelected(selected: LookupIcon) {
        // console.log(JSON.stringify(selected));
    }

    // @Watch('options')
    // public setUpColumns() {
    //     console.log(this.options)
    //     if (this.options && this.options.length && !this.isLoaded) {
    //         const sortedOptions = this.options.sort((a, b) => (a.display > b.display) ? 1 : -1)
    //         const copy = JSON.parse(JSON.stringify(sortedOptions));
    //         console.log(this.options)
    //         this.columnOptions = [];
    //         this.columns = +( this.options.length / 5).toFixed(0);
    //         for (let i = 0; i < this.columns; i++) {
    //             this.columnOptions.push([]);
    //             let x = 0;
    //             while (x < 5 && copy.length > 0) {
    //                 this.columnOptions[i].push(copy.shift());
    //                 x++;
    //             }
    //         }
    //         this.definedColumns = this.columnOptions;
    //         this.isLoaded = true;
    //     }
    //     this.definedColumns = [];
    // }
}
